import React, { FC } from 'react';

import { Layout } from '../../components/Layout';
import { ButtonWithLoading } from '../global/ButtonWithLoading';
import { useDispatchWithHistory } from '../actionWithHistory';
import { CrossButton } from '../../components/CrossButton';
import { useHistory } from '../navigation/router';
import { routes } from '../../domain/routes';
import { changeEmail } from './userSaga';
import { useForm } from 'react-hook-form';
import { Input } from '../forms/Input';

interface FormData {
  email: string;
}

const validateOptions = {
  required: 'email is required',
  pattern: {
    value:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    message: 'email is not valid',
  },
};

export const ChangeEmailPage: FC = () => {
  const dispatch = useDispatchWithHistory();
  const history = useHistory();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    dispatch(changeEmail, {
      email: data.email,
    });
  };

  const handleBack = () => {
    history.push(routes.profile);
  };

  return (
    <Layout
      footer={
        <footer className="l-footer">
          <ButtonWithLoading onClick={handleSubmit(onSubmit)}>Update</ButtonWithLoading>
        </footer>
      }
    >
      <CrossButton onClick={handleBack} />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="l-row">
          <div className="c-title">Update your email</div>
        </div>
        <div className="l-row">
          <Input
            label="email"
            initFormOption={register('email', validateOptions)}
            error={errors.email}
          />
        </div>
      </form>
    </Layout>
  );
};
